import { Observable } from 'rxjs'
import { BackGroundCheck } from '../models/background-check'

export abstract class BackGroundCheckGateway {
    abstract getBackGroundCheckData(): Observable<BackGroundCheck[]>
}
